import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RestaurantTable, RestaurantTableCreate, RestaurantTableFilter } from '../data/restaurantTable';

export function createRestaurantTableService(client: AxiosInstance) {
  return createCrudService<RestaurantTable, RestaurantTableCreate, RestaurantTableFilter>(
    client,
    '/restaurant/RestaurantTable',
    'restaurantTableId',
  );
}

export type RestaurantTableService = CrudService<RestaurantTable, RestaurantTableCreate, RestaurantTableFilter>;
